export default __webpack_public_path__ + "static/media/X33_CR7_Popout_V1-cn.c93f77e3.png";